var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconsTutorials = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 14.5239L3.33341 11.9906V7.99059L0.666748 6.52393L8.00008 2.52393L15.3334 6.52393V11.8573H14.0001V7.25726L12.6667 7.99059V11.9906L8.00008 14.5239ZM8.00008 8.99059L12.5667 6.52393L8.00008 4.05726L3.43341 6.52393L8.00008 8.99059ZM8.00008 13.0073L11.3334 11.2073V8.69059L8.00008 10.5239L4.66675 8.69059V11.2073L8.00008 13.0073Z",
    fill: "#E8EAED"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconsTutorials, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icons_tutorials.6c677217.svg";
export { ForwardRef as ReactComponent };